import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PowerComparison from "@/components/PowerComparison";

export const ComparisonTeaser = () => {
    const navigate = useNavigate();
    return (
        <section id="vergleich" className="relative scroll-mt-20 bg-[#0A0A0A] py-24">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-center gap-12 lg:grid-cols-2">
                    <div>
                        <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
                            Vorher · Nachher
                        </span>
                        <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Sieh das Potenzial deines Fahrzeugs
                        </h2>
                        <p className="mt-4 max-w-xl text-base leading-relaxed text-[#A1A1AA]">
                            Jede Analyse zeigt dir transparent die Serienleistung im Vergleich zur möglichen
                            Optimierung – inklusive PS, Drehmoment, Leistungsgewinn und prozentualer
                            Verbesserung. Realistische Werte, keine leeren Versprechen.
                        </p>

                        <motion.div
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            className="mt-8 grid grid-cols-3 gap-4"
                        >
                            {[
                                { v: "+30%", l: "Ø Leistung" },
                                { v: "+25%", l: "Ø Drehmoment" },
                                { v: "−0,5l", l: "Verbrauch" },
                            ].map((s) => (
                                <div key={s.l} className="rounded-xl border border-border bg-surface p-4 text-center">
                                    <div className="text-2xl font-bold text-white">{s.v}</div>
                                    <div className="mt-1 text-xs text-[#A1A1AA]">{s.l}</div>
                                </div>
                            ))}
                        </motion.div>

                        <button
                            data-testid="teaser-analyse-btn"
                            onClick={() => navigate("/analyse")}
                            className="group mt-8 inline-flex items-center gap-2 rounded-md bg-primary px-6 py-3.5 text-base font-bold text-white hover:bg-[#FF3B30] transition-colors"
                        >
                            Eigene Analyse starten
                            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                        </button>
                    </div>

                    <PowerComparison
                        serie_ps={190}
                        serie_nm={400}
                        opt_ps={230}
                        opt_nm={500}
                        stageName="Stage 1 · BMW 320d"
                        beschleunigung="ca. 0,8 s schneller 0–100"
                        verbrauch="bis zu 0,5 l/100km weniger"
                    />
                </div>
            </div>
        </section>
    );
};

export default ComparisonTeaser;
